import { useEffect, useState } from 'react'
import { addDays, startOfDay } from 'date-fns'
import { Controller } from 'react-hook-form'

import { AdapterDateFns, DatePicker, Fields, FormControlLabel, LocalizationProvider, Switch } from '..'

export function Scheduled({ register, errors, control, getValues, setValue, entity = 'Contribution' }) {
  const now = new Date()
  const minScheduledDate = startOfDay(addDays(now, 1))

  const [isFutureDate, setIsFutureDate] = useState(!!getValues('processingDate'))
  const [pickerValue, setPickerValue] = useState(getValues('processingDate'))
  useEffect(() => setValue('processingDate', isFutureDate ? pickerValue : null), [isFutureDate, pickerValue])

  return (
    <>
      <FormControlLabel
        control={<Switch checked={isFutureDate} onChange={(e) => setIsFutureDate(e.target.checked)} />}
        label="Schedule for Future"
      />
      {isFutureDate && (
        <Controller
          render={({ field }) => (
            <LocalizationProvider dateAdapter={AdapterDateFns}>
              <DatePicker
                {...field}
                label={`Schedule ${entity} For:`}
                value={pickerValue}
                onChange={(newValue) => {
                  const d = typeof newValue === 'string' ? new Date(newValue) : newValue
                  if (d && !Number.isNaN(d.getTime())) {
                    setPickerValue(new Date(Date.UTC(d.getFullYear(), d.getMonth(), d.getDate(), 12, 0, 0)))
                  }
                }}
                disablePast
                minDate={minScheduledDate}
                renderInput={(params) => (
                  <Fields.Text
                    {...params}
                    {...register('processingDate', {
                      validate: {
                        notInPast: (v) =>
                          new Date(v) >= minScheduledDate ||
                          `The date for a Scheduled ${entity} must be in the future.`,
                      },
                    })}
                    error={!!errors?.processingDate}
                    helperText={errors?.processingDate?.message}
                  />
                )}
              />
            </LocalizationProvider>
          )}
          control={control}
          name="processingDate"
          defaultValue={addDays(new Date(), 1)}
        />
      )}
    </>
  )
}
